import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import LanguageStack from "./languages";
import FrontendStack from "./frontend";
import BackendStack from "./backend";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px",paddingLeft:"17.5px", textAlign:"left"}}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "100px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
        <strong className="purple" style={{fontSize:"45px"}}>Skillset</strong>
        </h1>

        <h1 className="project-heading">
        <strong style={{fontSize:"28px"}}>Languages</strong>
        </h1>

         <LanguageStack/>

         <h1 className="project-heading">
        <strong style={{fontSize:"28px"}}>Front End </strong>
        </h1>
         <FrontendStack/>

         <h1 className="project-heading">
        <strong style={{fontSize:"28px"}}>Back End </strong>
        </h1>
         <BackendStack/>

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />
      </Container>
    </Container>
  );
}

export default About;
